import React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import './Sidebar.css';

const LogoIcon = () => (
 <img src="/sentradesk_logo.png" alt="Sentradesk" style={{height:'32px', objectFit:'contain'}} />
);

const ALL_NAV_GROUPS = [
  {
    label: 'MAIN MENU',
    items: [
      { path: '/',         label: 'Dashboard',       icon: <DashIcon/>,    adminOnly: true },
      { path: '/create',   label: 'Create Meeting',  icon: <CreateIcon/>,  adminOnly: true },
      { path: '/join',     label: 'Join Meeting',    icon: <JoinIcon/>,    adminOnly: false },
      { path: '/history',  label: 'Meeting History', icon: <HistoryIcon/>, adminOnly: true },
    ]
  },
  {
    label: 'PREFERENCES',
    items: [
      { path: '/settings', label: 'Settings',        icon: <SettingsIcon/>, adminOnly: true },
    ]
  }
];

function DashIcon()    { return <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="3" width="7" height="7" rx="1.5"/><rect x="14" y="3" width="7" height="7" rx="1.5"/><rect x="14" y="14" width="7" height="7" rx="1.5"/><rect x="3" y="14" width="7" height="7" rx="1.5"/></svg>; }
function CreateIcon()  { return <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M15 10l5 2-5 2"/><path d="M4 12h12"/><rect x="2" y="7" width="20" height="10" rx="2"/><circle cx="19" cy="12" r="0"/></svg>; }
function JoinIcon()    { return <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M15 3h6v6"/><path d="M10 14L21 3"/><path d="M18 13v6a2 2 0 01-2 2H5a2 2 0 01-2-2V8a2 2 0 012-2h6"/></svg>; }
function HistoryIcon() { return <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 3"/></svg>; }
function SettingsIcon(){ return <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="3"/><path d="M19.4 15a1.65 1.65 0 00.33 1.82l.06.06a2 2 0 010 2.83 2 2 0 01-2.83 0l-.06-.06a1.65 1.65 0 00-1.82-.33 1.65 1.65 0 00-1 1.51V21a2 2 0 01-4 0v-.09A1.65 1.65 0 009 19.4a1.65 1.65 0 00-1.82.33l-.06.06a2 2 0 01-2.83-2.83l.06-.06A1.65 1.65 0 004.68 15a1.65 1.65 0 00-1.51-1H3a2 2 0 010-4h.09A1.65 1.65 0 004.6 9a1.65 1.65 0 00-.33-1.82l-.06-.06a2 2 0 012.83-2.83l.06.06A1.65 1.65 0 009 4.68a1.65 1.65 0 001-1.51V3a2 2 0 014 0v.09a1.65 1.65 0 001 1.51 1.65 1.65 0 001.82-.33l.06-.06a2 2 0 012.83 2.83l-.06.06A1.65 1.65 0 0019.4 9a1.65 1.65 0 001.51 1H21a2 2 0 010 4h-.09a1.65 1.65 0 00-1.51 1z"/></svg>; }
function LogoutIcon() { return <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M9 21H5a2 2 0 01-2-2V5a2 2 0 012-2h4"/><polyline points="16 17 21 12 16 7"/><line x1="21" y1="12" x2="9" y2="12"/></svg>; }

const Sidebar = ({ collapsed, onToggle }) => {
  const navigate = useNavigate();
  const role = localStorage.getItem('loginRole') || 'user';
  const isAdmin = role === 'admin';

  // Filter nav items based on role
  const NAV_GROUPS = ALL_NAV_GROUPS
    .map(group => ({
      ...group,
      items: group.items.filter(item => !item.adminOnly || isAdmin)
    }))
    .filter(group => group.items.length > 0);

  const handleLogout = () => {
    localStorage.removeItem('isLoggedIn');
    localStorage.removeItem('loginEmail');
    localStorage.removeItem('loginRole');
    localStorage.removeItem('loginTime');
    navigate('/login');
  };
  return (
    <aside className={`sidebar${collapsed ? ' collapsed' : ''}`}>

      {/* ── Logo ── */}
      <div className="sb-logo">
        <LogoIcon />
        {!collapsed && (
          <div className="sb-logo-text">
            <span className="sb-logo-name">Sentradesk</span>
            <span className="sb-logo-sub">AI Interpretation</span>
          </div>
        )}
        <button className="sb-toggle-btn" onClick={onToggle} title="Toggle sidebar">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round">
            {collapsed ? <path d="M9 18l6-6-6-6"/> : <path d="M15 18l-6-6 6-6"/>}
          </svg>
        </button>
      </div>

      {/* ── Navigation ── */}
      <nav className="sb-nav">
        {NAV_GROUPS.map((group) => (
          <div className="sb-group" key={group.label}>
            {!collapsed && <p className="sb-group-label">{group.label}</p>}
            {group.items.map((item) => (
              <NavLink
                key={item.path}
                to={item.path}
                end={item.path === '/'}
                className={({ isActive }) => `sb-item${isActive ? ' active' : ''}`}
                title={collapsed ? item.label : undefined}
              >
                <span className="sb-item-icon">{item.icon}</span>
                {!collapsed && <span className="sb-item-label">{item.label}</span>}
              </NavLink>
            ))}
          </div>
        ))}
      </nav>

      {/* ── Logout ── */}
      <button className="sb-logout-btn" onClick={handleLogout} title="Sign Out">
        <span className="sb-item-icon"><LogoutIcon/></span>
        {!collapsed && <span className="sb-item-label">Sign Out</span>}
      </button>

      {/* ── Footer ── */}
      {!collapsed && (
        <div className="sb-footer">
          <span className="sb-status-dot" />
          <span className="sb-status-text">AI Engine Online</span>
        </div>
      )}
    </aside>
  );
};

export default Sidebar;
